import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import { AccountErrorFragment } from "@saleor/fragments/types/AccountErrorFragment";
import useModalDialogErrors from "@saleor/hooks/useModalDialogErrors";
import { buttonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { DialogProps } from "@saleor/types";
import { getFormErrors } from "@saleor/utils/errors";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import {
  checkError,
  hasNoError,
  usePasswordValidation
} from "./PasswordValidations";

interface OtherStaffPasswordResetDialogFormData {
  confirmPassword: string;
  newPassword: string;
  user: string;
}

const useStyles = makeStyles(
  _ => ({
    hideIcon: {
      position: "absolute",
      right: "30px",
      zIndex: 10
    },
    hideIconWithDescription: {
      marginBottom: "19px",
      position: "absolute",
      right: "30px",
      zIndex: 10
    },
    rowView: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row"
    }
  }),
  {
    name: "TranslationFieldsSave"
  }
);

export interface OtherStaffPasswordResetDialogProps extends DialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  errors: AccountErrorFragment[];
  onSubmit: (data: OtherStaffPasswordResetDialogFormData) => void;
  // onChange: (data: OtherStaffPasswordResetDialogFormData) => void;
  userId: string;
}

const StaffPasswordResetDialog: React.FC<OtherStaffPasswordResetDialogProps> = props => {
  const { confirmButtonState, errors, open, onClose, onSubmit, userId } = props;

  const intl = useIntl();
  const classes = useStyles(props);
  const dialogErrors = useModalDialogErrors(errors, open);
  const [securedNewPassword, setSecuredNewPassword] = useState(true);
  const [securedConfirmPassword, setSecuredConfirmPassword] = useState(true);
  const [validationError, setValidationError] = useState({
    confirmPassword: null,
    newPassword: null
  });

  // useEffect(() => {
  //   if (staffMember?.id) {
  //     onChange({
  //       target: {
  //         name: "user",
  //         value: staffMember.id
  //       }
  //     });
  //   }
  // }, [staffMember]);
  const initialForm: OtherStaffPasswordResetDialogFormData = {
    confirmPassword: "",
    newPassword: "",
    user: maybe(() => userId, "")
  };

  const formErrors = getFormErrors(
    ["newPassword", "confirmPassword"],
    dialogErrors
  );

  const getError = key => checkError(key, formErrors, validationError, intl);

  const handleSubmit = event => {
    const validate = usePasswordValidation(event);
    if (hasNoError(validate)) {
      onSubmit(event);
    } else {
      setValidationError(validate);
    }
  };
  // console.log(StaffDetailsPage)

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        <FormattedMessage
          defaultMessage="Update Your Password"
          description="dialog header"
        />
      </DialogTitle>
      <Form initial={initialForm} onSubmit={handleSubmit}>
        {({ change, submit }) => (
          <>
            <DialogContent>
              <FormSpacer />
              <div className={classes.rowView}>
                <TextField
                  error={getError("newPassword").hasError}
                  fullWidth
                  helperText={getError("newPassword").message}
                  label={intl.formatMessage({
                    defaultMessage: "New Password",
                    description: "input label"
                  })}
                  name="newPassword"
                  type={securedNewPassword ? "password" : ""}
                  onChange={change}
                />
                <IconButton
                  className={
                    getError("newPassword").hasError
                      ? classes.hideIconWithDescription
                      : classes.hideIcon
                  }
                  onClick={() => setSecuredNewPassword(!securedNewPassword)}
                >
                  {securedNewPassword ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <VisibilityOutlinedIcon />
                  )}
                </IconButton>
              </div>
              <FormSpacer />
              <div className={classes.rowView}>
                <TextField
                  error={getError("confirmPassword").hasError}
                  fullWidth
                  helperText={getError("confirmPassword").message}
                  label={intl.formatMessage({
                    defaultMessage: "Confirm Password",
                    description: "input label"
                  })}
                  name="confirmPassword"
                  type={securedConfirmPassword ? "password" : ""}
                  onChange={change}
                />
                <IconButton
                  className={
                    getError("confirmPassword").hasError
                      ? classes.hideIconWithDescription
                      : classes.hideIcon
                  }
                  onClick={() =>
                    setSecuredConfirmPassword(!securedConfirmPassword)
                  }
                >
                  {securedConfirmPassword ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <VisibilityOutlinedIcon />
                  )}
                </IconButton>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>
                <FormattedMessage {...buttonMessages.close} />
              </Button>
              <ConfirmButton
                transitionState={confirmButtonState}
                color="primary"
                variant="contained"
                type="submit"
                onClick={() => () => submit()}
              >
                <FormattedMessage {...buttonMessages.submit} />
              </ConfirmButton>
            </DialogActions>
          </>
        )}
      </Form>
    </Dialog>
  );
};

StaffPasswordResetDialog.displayName = "StaffPasswordResetDialog";
export default StaffPasswordResetDialog;
